var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-checkbox',{model:{value:(_vm.fl),callback:function ($$v) {_vm.fl=$$v},expression:"fl"}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }